module.exports = {"140426100":"黎侯镇","140426101":"东阳关镇","140426102":"上遥镇","140426103":"西井镇","140426104":"黄崖洞镇","140426200":"西仵乡","140426201":"停河铺乡","140426202":"程家山乡","140426203":"洪井乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140426.json
// module id = 262
// module chunks = 0